import { Dispatch, SetStateAction, useEffect } from "react";

import { TABLE_NAMES } from "@/shared";
import SelectedRowsTag from "@/shared/components/tags/SelectedRowsTag";

import { getPayloadObject } from "../../..";

interface IActivateVehicleDialogContentProps {
  selectedRows: string[];
  setPayload: Dispatch<SetStateAction<object | null>>;
}

const ActivateVehicleDialogContent = ({
  selectedRows,
  setPayload
}: IActivateVehicleDialogContentProps) => {
  const resourceCount = selectedRows?.length;

  useEffect(() => {
    setPayload(getPayloadObject(TABLE_NAMES.Vehicles, selectedRows));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows, setPayload]);

  return (
    <SelectedRowsTag
      resourceName={TABLE_NAMES.Vehicles}
      resourceCount={resourceCount}
    />
  );
};

export default ActivateVehicleDialogContent;
